var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9242 25.4414C20.4125 25.9297 21.2039 25.9297 21.6922 25.4414L22.5758 24.5578C23.0641 24.0695 23.0641 23.2781 22.5758 22.7898L19.7852 20L22.575 17.2094C23.0633 16.7211 23.0633 15.9297 22.575 15.4414L21.6914 14.5578C21.2031 14.0695 20.4117 14.0695 19.9234 14.5578L15.3656 19.1156C14.8773 19.6039 14.8773 20.3953 15.3656 20.8836L19.9242 25.4414ZM27.425 24.5586L28.3086 25.4422C28.7969 25.9305 29.5883 25.9305 30.0766 25.4422L34.6344 20.8844C35.1227 20.3961 35.1227 19.6047 34.6344 19.1164L30.0766 14.5586C29.5883 14.0703 28.7969 14.0703 28.3086 14.5586L27.425 15.4422C26.9367 15.9305 26.9367 16.7219 27.425 17.2102L30.2148 20L27.425 22.7906C26.9367 23.2789 26.9367 24.0703 27.425 24.5586ZM48.75 37.5H29.8078C29.75 39.0477 28.6586 40 27.25 40H22.5C21.0398 40 19.9203 38.6352 19.9398 37.5H1.25C0.5625 37.5 0 38.0625 0 38.75V40C0 42.75 2.25 45 5 45H45C47.75 45 50 42.75 50 40V38.75C50 38.0625 49.4375 37.5 48.75 37.5ZM45 8.75C45 6.6875 43.3125 5 41.25 5H8.75C6.6875 5 5 6.6875 5 8.75V35H45V8.75ZM40 30H10V10H40V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    stroke: "url(#paint0_linear_1_224)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_224",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopCode);
export default __webpack_public_path__ + "static/media/laptop-code.e922de9fd5ef721e600113f7e97771d5.svg";
export { ForwardRef as ReactComponent };